// extracted by mini-css-extract-plugin
module.exports = {"body":"BottomDrawer_body__w4YyZ","description":"BottomDrawer_description__OYwut","separator":"BottomDrawer_separator__lvECR","titleRow":"BottomDrawer_titleRow__dlqGZ"};